import { CommissionService } from '@app/shared/components/requests/commissions/service/commission.service';
import { Component, OnInit, Input, Inject, ViewEncapsulation } from '@angular/core';
import { CommissionResult } from '../../models';
import { CommissionType, RequestType } from '@app/shared/types';
import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { CommissionCalcType } from '../../types';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TcCurrencyPipe } from '@app/shared/pipes';

@Component({
    selector: 'tc-invoice-exchange-last',
    imports: [
        CommonModule,
        TranslateModule,
        TcCurrencyPipe
    ],
    templateUrl: './invoice-exchange-last.component.html',
    styleUrls: ['./invoice-exchange-last.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceExchangeLastComponent implements OnInit {

  @Input() commission: CommissionResult;
  @Input() rowCountIsEven: boolean;
  @Input() getAmountTitle: string;
  @Input() payAmountTitle: string;
  @Input() requestType: RequestType;

  pointPrecision: number;

  // types
  commissionType = CommissionType;
  commissionCalcType = CommissionCalcType;
  requestTypes = RequestType;

  constructor(
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
    private commissionService: CommissionService
  ) {

  }

  ngOnInit() {
    this.pointPrecision = this.appConfig.pointPrecision;
    if (!this.commission) {
      this.commission = this.commissionService.commissionResult;
    }
  }

}
